import { Flex } from '@chakra-ui/react';
import DashboardNavigationMenu from '../../sidebar/components/DashboardNavigationMenu';


export default function NavigationMenuHeader({isMobileView, isGuestMode}) {

	return (
		<Flex direction='row' bg='white' justify="space-between">
			{isMobileView ? null : 
				<DashboardNavigationMenu isGuestMode={isGuestMode} />
			}
		</Flex>
	);
	
}